<template>
    <div style="text-align: center;">
        <div v-if="!isSendAuthNumber">
            <div style="font-size: 32px; font-weight: 700; line-height: 46px;">전화번호를 알려주세요</div>
            <div style="margin-top: 16px;">
                <div>
                    <input class="common_input" placeholder="숫자만 입력하세요" type="tel" ref="phoneInput" v-model="phone">
                </div>
                <div @click="sendAuthNumber" :style="{ backgroundColor: phone === '' ? '#ffd2b3' : 'var(--color-main)' }" style="margin: 0 auto; height: 48px; margin-top: 12px; border-radius: 12px; width: 310px; line-height: 48px; color: #fff; font-weight: 500; font-size: 14px; text-align: center;">인증코드 보내기</div>
            </div>
        </div>
        <div v-else style="">
            <div style="font-size: 32px; font-weight: 700; line-height: 46px;">인증코드를 입력하세요</div>
            <div style="margin-top: 16px;">
                <input class="common_input" placeholder="인증코드" type="tel" maxlength="6" v-model="authNumber">
            </div>
            <div @click="checkAuthNumber" :style="{ backgroundColor: authNumber === '' ? '#ffd2b3' : 'var(--color-main)' }" style="margin: 0 auto; height: 48px; margin-top: 12px; border-radius: 12px; width: 310px; line-height: 48px; background-color: #ffd2b3; color: #fff; font-weight: 500; font-size: 14px; text-align: center;">다음</div>
        </div>
    </div>
</template>

<script>
import { REGIST_STEP } from '@/Constants';
import {LOGIN_PLATFORM} from "../../Constants";
import ResponseCode from "../../ResponseCode";

export default {
    name: 'VerificationPhoneNumber',
    props: {
        isSendAuthNumber: {
            type: Boolean,
            default: false
        },
        receivedPhoneNumber: {
            type: String,
            default: ''
        },
        registInfo: {
            type: Object,
            default: () => { }
        },
        mode: {
            type: String,
            default: 'insert'
        },
        platform: {
            type: Number,
            default: -1
        },
        platform_id : {
            type : String,
            default : '',
        }
    },
    data() {
        return {
            phone: '',
            authNumber: ''
        }
    },
    methods: {
        async sendAuthNumber(isAgain) {
            // if (this.phone === '') {
            //     this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.PHONE, progress: 2, isSendAuthNumber: true, receivedPhoneNumber: this.phone, receivedRegistInfo: this.registInfo, mode: this.mode })
            //     return
            // }
            if (!this.phone && this.phone.length !== 13) {
                this.$GlobalStore.showAlert("휴대폰번호를 입력해주세요.");
                return;
            }

            const parameters = {};
            parameters.phone = this.phone;
            parameters.duple = "0";

            const res = await this.$Axios.post("/api/auth/number", parameters);
            if (res.data.code === 0) {
                this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.PHONE, progress: 2, isSendAuthNumber: true, receivedPhoneNumber: this.phone, receivedRegistInfo: this.registInfo, mode: this.mode, platform: this.platform })
                if (isAgain === true) {
                    alert("인증 번호를 다시 전송했습니다. 잠시만 기다려주세요");
                }
            } else {
                alert(res.data.msg);
            }
        },
        async checkAuthNumber() {
            // if (this.phone === '') {
            //     this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.NAME, progress: 3, isShowNextBtn: true, receivedAuthNumber: this.authNumber, receivedPhoneNumber: this.receivedPhoneNumber, receivedRegistInfo: this.registInfo, mode: this.mode })
            //     return
            // }
            if (!this.authNumber) {
                alert("인증번호를 입력해주세요.");
                return;
            }
            if (this.receivedPhoneNumber === '') {
                alert("휴대폰번호를 입력해주세요.");
                return;
            }

            const parameters = {};
            parameters.phone = this.receivedPhoneNumber;

            parameters.authNumber = this.authNumber;

            const res = await this.$Axios.post("/api/auth/check", parameters);
            if (res.data.code === 0) {
                this.$GlobalStore.addModal('SignupCommonFrame', {
                    step: REGIST_STEP.NAME,
                    progress: 3,
                    isShowNextBtn: true,
                    receivedAuthNumber: this.authNumber,
                    receivedPhoneNumber: this.receivedPhoneNumber,
                    receivedRegistInfo: this.registInfo,
                    mode: this.mode,
                    platform: this.platform
                })
            //이미 가입된 휴대폰번호일때. 사커하우 로그인이면 이미 가입된 휴대폰번호라고 안내.
            //소셜 로그인이면 해당 로그인 방식으로 변경할건지 물은 후 변경처리
            } else if(res.data.code === 1){

                let currnet_login_platform_str = '';
                if(this.platform === LOGIN_PLATFORM.KAKAO){
                    currnet_login_platform_str = '카카오';
                }else if(this.platform === LOGIN_PLATFORM.APPLE){
                    currnet_login_platform_str = '애플';
                }else if(this.platform === LOGIN_PLATFORM.NAVER){
                    currnet_login_platform_str = '네이버';
                }else if(this.platform === LOGIN_PLATFORM.GOOGLE){
                    currnet_login_platform_str = '구글';
                }

                //사커하우 로그인일경우
                if(currnet_login_platform_str === ''){
                    this.$GlobalStore.showAlert('이미 가입된 휴대폰번호입니다.');
                    return;
                }

                let confirm_str = `다른 로그인 플랫폼을 통해서 가입한적이 있는 휴대폰 번호입니다.\n`;
                confirm_str += `해당 휴대폰 번호로 등록된 계정의 로그인 플랫폼을 ${currnet_login_platform_str}으로 변경하시겠습니까?`;
                if(!confirm(confirm_str)){
                    return;
                }

                if(this.platform_id === ''){
                    alert('플랫폼 아이디 빔');
                    return;
                }


                //TODO 이전에 가입한 아이디의 로그인 방식 변경 후 로그인.
                const login_parameters = window.copyObject(parameters);
                login_parameters.id = this.platform_id;
                login_parameters.platform = this.platform;
                const login_res = await this.$Axios.post('/login/platform/change', login_parameters);
                if(login_res.data.code === ResponseCode.SUCCESS){
                    this.$GlobalStore.closeModalAll(true);
                    this.$GlobalStore.closeLastModal(true);
                    this.$GlobalStore.closeLastModal(true);

                    const login_res = await this.$Axios.get('/login/data');
                    localStorage.removeItem('marketing_agree');
                    this.$GlobalStore.setLoginInfo(login_res.data.loginInfo);
                    await this.$Util.checkAfterLogin(login_res.data.isSoccerhowWritten);
                }else if(login_res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                    return;
                }

            } else {
                alert(res.data.msg);
                return;
            }
        },
    },
    mounted() {
        if (this.$refs.phoneInput) {
            this.$Util.setPhoneFormatter(this.$refs.phoneInput);
        }
        console.log(this.mode)
    },
    created() {
        this.sendAuthNumber = this.$Once(this.sendAuthNumber)
        this.checkAuthNumber = this.$Once(this.checkAuthNumber)
    }
}
</script>

<style scoped>
.common_input {
    width: 310px;
    height: 56px;
    outline: none;
    border-radius: 12px;
    border: none;
    padding: 0 12px;
}

.common_input::placeholder {
    font-size: 20px;
    font-weight: 500;
    color: #bbbbbb;
}
</style>